<!--供应商管理 供应商列表 - 产品管理-->
<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h3>供应商名称：{{ this.supplierName }}</h3>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="产品状态：" v-if="userPriceType == 1">
            <el-select size="medium" filterable v-model="searchForm.ON_SALE" placeholder="请选择" @change="querySearch">
              <el-option v-for="item in statusList" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" v-if="this.searchForm.ON_SALE == 0 && userPriceType == 1" @click="批量在售()" style="margin-top:20px">
          批量在售
        </el-button>
        <el-button size="medium" v-if="this.searchForm.ON_SALE == 1 && userPriceType == 1" @click="批量不在售()" style="margin-top:20px">
          批量不在售
        </el-button>
        <el-button size="medium" @click="addProduct" style="margin-top:20px">新增产品</el-button>
        <el-button size="medium" type="primary" plain @click="exportOut" style="margin-top:20px">价格导出</el-button>
        <el-button size="medium" @click="importProduct" style="margin-top:20px">价格导入</el-button>
        <el-button size="medium" @click="exportAllMoney" style="margin-top:20px" v-if="userPriceType == 1">
          批量下架
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px" @selection-change="(val) => 在售转换订单勾选(val)">
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="状态" min-width="50">
            <template slot-scope="scope">
              <span :style="{ 'color': scope.row.ON_SALE ? '#67c23a' : '#f56c6c' }">
                {{ statusList.find(({ status }) => status == scope.row.ON_SALE).name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="价格" prop="PRICE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="不含税价格" prop="PRICE_WITHOUT_TAX" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="税率" prop="TAX_RATE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="开始日期" prop="START_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="结束日期" prop="END_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="当期价格" prop="CURRENT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="当期不含税价" prop="PRICE_WITHOUT_TAX" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期价格" prop="NEXT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期不含税价" prop="NEXT_PRICE_WITHOUT_TAX" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="税率" prop="TAX_RATE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期生效日期" prop="NEXT_EFFECTIVE_DATE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="是否自动生成" prop="NEXT_EFFECTIVE_DATE" v-if="userPriceType == 2">
            <template slot-scope="scope">
              <span>{{ scope.row.AUTO_PRODUCED == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否为缺省" prop="BE_DEFAULT" v-if="userPriceType == 1">
            <template slot-scope="scope">
              <span>{{ showDefault[scope.row.BE_DEFAULT] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="updateData(scope.row)">修改</el-button>
              <el-button type="text" style="color: rgb(245, 108, 108)" @click="soldOut(scope.row)">下架</el-button>
              <el-button type="text" v-if="scope.row.ON_SALE == 0 && userPriceType == 1" @click="商品在售(scope.row)">
                在售
              </el-button>
              <el-button type="text" v-if="scope.row.ON_SALE == 1 && userPriceType == 1" @click="商品不在售(scope.row)">
                不在售
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 修改价格 -->
    <el-dialog title="修改价格" center :visible.sync="editFormVisible" width="500px">
      <el-form :model="editForm" ref="editForm">
        <div v-if="userPriceType == 2">
          <el-form-item label="单价：" :label-width="formLabelWidth">
            <el-input v-model="editForm.PRICE" @input="getEditPriceWithoutTax"></el-input>
          </el-form-item>
          <el-form-item label="不含税单价：" :label-width="formLabelWidth">
            <el-input v-model="editForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="开始日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="editForm.START_DAY" align="right" type="date" @change="selectData" placeholder="选择日期" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1" style="width:100%" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="editForm.END_DAY" align="right" type="date" @change="selectData" placeholder="选择日期" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1" style="width:100%" :clearable="false">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="当期价格:" :label-width="formLabelWidth">
            <el-input v-model="editForm.CURRENT_PRICE" :placeholder="nowPrice" clearable @input="getEditPriceWithoutTax">
            </el-input>
          </el-form-item>
          <el-form-item label="当期不含税价格:" :label-width="formLabelWidth">
            <el-input v-model="editForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="下期价格:" :label-width="formLabelWidth">
            <el-input v-model="editForm.NEXT_PRICE" :placeholder="nowPrice" clearable @input="getEditNextPriceWithoutTax">
            </el-input>
          </el-form-item>
          <el-form-item label="下期不含税价格:" :label-width="formLabelWidth">
            <el-input v-model="editForm.NEXT_PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="生效日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="editForm.NEXT_EFFECTIVE_DATE" align="right" type="date" :clearable="false" @change="editSelectData"
              placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="是否为缺省：" prop="BE_DEFAULT" :label-width="formLabelWidth" v-if="userPriceType == 1">
          <el-radio v-model="editForm.BE_DEFAULT" label="0">否</el-radio>
          <el-radio v-model="editForm.BE_DEFAULT" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog title="导入供应商价格" center :visible.sync="addFormVisible" width="500px">
      <el-form ref="addForm" v-model="addForm" style="margin-left: 30px">
        <el-form-item label="生效日期：" :label-width="formLabelWidth" v-if="userPriceType == 1">
          <el-date-picker v-model="addForm.EFFECTIVE_DATE" align="right" type="date" @change="selectData" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width:100%">
          </el-date-picker>
        </el-form-item>
        <!--        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"-->
        <!--          :on-remove="handleRemove" :name="this.addForm.file" multiple :file-list="fileList">-->
        <!--          <el-button size="small" type="primary">点击上传</el-button>-->
        <!--        </el-upload>-->

        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <limit-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
            :name="this.addForm.file" multiple :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </limit-upload>
          <p style="color: #409EFF" @click="downloadTmp">点击下载导入模板</p>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button @click="submitEnter('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量下架 -->
    <el-dialog :visible.sync="exportTaxDialog" @close="exportTaxDialog = false" title="批量下架" width="400px" center>
      <el-form ref="exportTax" v-model="exportTax">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccesst"
          :name="this.exportTax.supplierPrice" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList1">
          <el-button size="small" type="primary">点击上传</el-button>
          <p @click="downLoadSKU" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportTaxDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportTax">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导出价格 -->
    <el-dialog :visible.sync="outExportDialog" @close="outExportDialog = false" title="导出价格" width="400px" center>
      <el-form ref="outExportForm" v-model="outExportForm">
        <el-date-picker v-model="outExportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="outExportDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="exportProduct">确认</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { querySupOrderFun } from 'api/systemSetting';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      statusList: [{ status: null, name: '全部' }, { status: 0, name: '不在售' }, { status: 1, name: '在售' }],
      tableData: [],
      勾选产品的编码集合: [],
      loadSearch: false,
      // loadEdit: false,
      kindsId: sessionStorage.getItem('kindId'),
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {
        ON_SALE: 1,
      },
      addForm: {
        file: 'supplierPrice',
      },
      exportTaxDialog: false,
      addFormVisible: false,
      editForm: {},
      editFormVisible: false,
      formLabelWidth: '120px',
      nowPrice: '',
      fileList: [],
      fileList1: [],
      exportTax: {
        supplierPrice: 'supplierPrice',
      },
      // loading: false,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      showDefault: ['否', '是'],
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      outExportForm: {},
      supplierName: sessionStorage.getItem('supplierNameAboutProducts') || '',
      outExportDialog: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  methods: {
    在售转换订单勾选(val) {
      this.勾选产品的编码集合 = val.map(({ PRODUCT_CODE }) => PRODUCT_CODE);
    },
    addProduct() {
      this.$router.push({ name: 'addNewProduct' });
      sessionStorage.setItem('kindId', this.kindsId);
    },
    // 批量下架
    exportAllMoney() {
      this.exportTaxDialog = true;
    },
    closeTax() {
      this.exportTaxDialog = false;
    },
    handleExportTax() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 33,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.file_name,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
        this.exportTaxDialog = false;
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    downLoadSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/GYSDeleteProducttemp.xls';
    },
    handleSuccesst(response, file, fileList1) {
      this.file_name = response.file_name;
    },
    // matchProduct(){
    //   this.$router.push({name: 'matchProduct'})
    // },
    // --------------------------------------进入页面拉取数据
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.ON_SALE !== null) {
        params.ON_SALE = this.searchForm.ON_SALE;
      }
      this.loadSearch = true;
      querySupOrderFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list.map((item) => ({
            ...item,
            PRICE_WITHOUT_TAX: item.PRICE_WITHOUT_TAX.toFixed(2),
            NEXT_PRICE_WITHOUT_TAX: this.userPriceType == 1 ? item.NEXT_PRICE_WITHOUT_TAX.toFixed(2) : '',
            TAX_RATE: item.TAX_RATE.toFixed(2),
          }));
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.loadSearch = false;
    },
    querySearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryTable();
    },
    // 导出
    exportOut() {
      if (this.userPriceType == 2) {
        this.outExportDialog = true;
      } else {
        this.exportProduct();
      }
    },
    exportProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10008',
            OTYPE: 24,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRICE_MODE: this.userPriceType,
          };
          if (this.userPriceType == 2) {
            if (this.outExportForm.DAY_INTERVAL) {
              params.START_DAY = this.outExportForm.DAY_INTERVAL[0];
              params.END_DAY = this.outExportForm.DAY_INTERVAL[1];
            } else {
              this.$message.show({ text: '请选择日期', type: 'error' });
              document.body.style.cursor = 'default';
              return false;
            }
          }
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // 导入
    importProduct() {
      this.addFormVisible = true;
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
      this.file_name = '';
    },
    selectData(e) {
      this.addForm.EFFECTIVE_DATE = e;
    },
    editSelectData(e) {
      this.editForm.NEXT_EFFECTIVE_DATE = e;
    },
    // 导入模态框的提交
    submitEnter() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      if (!this.addForm.EFFECTIVE_DATE && this.userPriceType == 1) {
        this.$message.show({ text: '请输入生效日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 25,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        EFFECTIVE_DATE: this.addForm.EFFECTIVE_DATE,
        FILE_NAME: this.url,
        PRICE_MODE: this.userPriceType,
      };
      http.post(params).then((result) => {
        if (result[0].FILE_PATH == '') {
          this.$message.show({ text: '导入成功', type: 'success' });
          this.url = '';
          this.addFormVisible = false;
          this.fileList = [];
          this.queryTable();
          document.body.style.cursor = 'default';
        } else {
          this.$message.show({ text: '导入失败，详情查看下载文件', type: 'error' });
          this.url = '';
          this.addFormVisible = false;
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.fileList = [];
          document.body.style.cursor = 'default';
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.url = '';
        document.body.style.cursor = 'default';
      });
    },
    // 修改价格
    updateData(row) {
      this.editForm = { ...row };
      this.editFormVisible = true;
    },
    submitEdit() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (this.userPriceType == 1) {
        if (!reg.test(this.editForm.CURRENT_PRICE) || !reg.test(this.editForm.NEXT_PRICE) || !this.editForm.NEXT_EFFECTIVE_DATE) {
          this.$message.show({ text: '数据输入有误', type: 'warning' });
          return false;
        }
      } else {
        if (!reg.test(this.editForm.PRICE) || !this.editForm.START_DAY || !this.editForm.END_DAY) {
          this.$message.show({ text: '数据输入有误', type: 'warning' });
          return false;
        }
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10008',
            OTYPE: 26,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            CURRENT_PRICE: this.editForm.CURRENT_PRICE,
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            NEXT_PRICE: this.editForm.NEXT_PRICE,
            NEXT_EFFECTIVE_DATE: this.editForm.NEXT_EFFECTIVE_DATE,
            BE_DEFAULT: this.editForm.BE_DEFAULT,
            PRICE_MODE: this.userPriceType,
          };
          if (this.userPriceType == 2) {
            params.DETAIL_ID = this.editForm.ID;
            params.PRICE = this.editForm.PRICE;
            params.START_DAY = this.editForm.START_DAY;
            params.END_DAY = this.editForm.END_DAY;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
          this.editFormVisible = false;
          document.body.style.cursor = 'default';
        } finally { }
      }
    },
    批量不在售() {
      if (this.勾选产品的编码集合 == '') {
        this.$message.show({ text: '请勾选产品', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 27,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE_LIST: this.勾选产品的编码集合,
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        ON_SALE: 0,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    商品不在售(row) {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 27,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE_LIST: [row.PRODUCT_CODE],
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        ON_SALE: 0,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    批量在售() {
      if (this.勾选产品的编码集合 == '') {
        this.$message.show({ text: '请勾选产品', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 27,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE_LIST: this.勾选产品的编码集合,
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        ON_SALE: 1,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    商品在售(row) {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 27,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE_LIST: [row.PRODUCT_CODE],
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        ON_SALE: 1,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 下架商品
    soldOut(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10008',
            OTYPE: 21,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCT_CODE: row.PRODUCT_CODE,
            PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
            DETAIL_ID: row.ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    downloadTmp() {
      if (this.userPriceType == 1) {
        window.location.href = 'https://service.linkda.com.cn/file/templates/gysvendorpricetemp.xlsx';
      } else {
        window.location.href = 'https://service.linkda.com.cn/file/templates/pm2vendorpriceTemp.xls';
      }
    },
    getEditPriceWithoutTax(e) {
      this.editForm.PRICE_WITHOUT_TAX = (Number(e) / (1 + this.editForm.TAX_RATE / 100)).toFixed(2);
    },
    getEditNextPriceWithoutTax(e) {
      this.editForm.NEXT_PRICE_WITHOUT_TAX = (Number(e) / (1 + this.editForm.TAX_RATE / 100)).toFixed(2);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/skuProducts.vue